import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from '../../library/axios';
import {
  CPANEL_LOGIN_PATH,
  notifyCentralUserUpdated,
  setCpanelToken,
} from '../../helpers/cpanelAuth';
import { useCpanelDocumentTitle } from '../../helpers/useCpanelDocumentTitle';

const safeNextPath = (value) => {
  const next = String(value || '').trim();
  if (!next.startsWith('/cpanel') || next.startsWith('/cpanel/sso')) {
    return '/cpanel/dashboard';
  }
  return next;
};

const CpanelSsoPage = () => {
  useCpanelDocumentTitle('Masuk');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('Membuka CPanel Center…');

  useEffect(() => {
    const code = searchParams.get('code');
    const next = safeNextPath(searchParams.get('next'));

    if (!code) {
      navigate(CPANEL_LOGIN_PATH, { replace: true });
      return undefined;
    }

    let active = true;

    axios
      .post('/cpanel/auth/sso', { code })
      .then(({ data }) => {
        if (!active) return;
        if (!data?.token) {
          throw new Error('Token SSO tidak tersedia');
        }

        setCpanelToken(data.token);
        notifyCentralUserUpdated(data.user);
        navigate(next, { replace: true });
      })
      .catch((error) => {
        if (!active) return;
        const text = error?.response?.data?.message || error?.message || 'SSO gagal. Silakan login manual.';
        setMessage(text);
        navigate(`${CPANEL_LOGIN_PATH}?error=${encodeURIComponent(text)}`, { replace: true });
      });

    return () => {
      active = false;
    };
  }, [navigate, searchParams]);

  return (
    <div className="d-flex min-vh-100 align-items-center justify-content-center p-4">
      <p className="text-muted fs-6 mb-0">{message}</p>
    </div>
  );
};

export default CpanelSsoPage;
